// Angular
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CalamityBasicDetailsComponent } from "./calamity-details/calamity-basic-details/calamity-basic-details.component";

// Components 
import { CalamityListComponent } from "./calamity-list/calamity-list.component";
import { CalamityWizardComponent } from "./calamity-details/calamity-wizard.component";
import { CalamityActionsListComponent } from "./calamity-details/calamity-actions/calamity-actions-list/calamity-actions-list.component";
import { CalamityNotesListComponent } from "./calamity-details/calamity-notes/calamity-notes-list/calamity-notes-list.component";
import { CalamityDossierListComponent } from "./calamity-dossier-list/calamity-dossier-list.component";

const routes: Routes = [
  {
    path: "",
    data: {
      title: "calamity",
      breadcrumbs: "",
    },
    children: [
      {
        path: "calamityList",
        component: CalamityListComponent,
      },
      {
        path: "calamityWizard",
        component: CalamityWizardComponent,
        children: [
          {
            path: "calamityBasicDetails",
            component: CalamityBasicDetailsComponent,
          },
          {
            path: "calamityActionsList",
            component: CalamityActionsListComponent,
          },
          {
            path: "calamityNotesList",
            component: CalamityNotesListComponent,
          },
          {
            path: "calamityDossierList",
            component: CalamityDossierListComponent,
          },
        ]
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CalamityRoutingModule { }